import React from 'react';
import { connect } from 'react-redux';
import ReceiptUploadsTable from './table';

const ReceiptUploadsList = () => (
  <>
    <div className="content-header">
      <h1>Receipt Uploads</h1>
    </div>

    <ReceiptUploadsTable />
  </>
);

ReceiptUploadsList.postTypes = {};

export default connect(null, {})(ReceiptUploadsList);
